/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react'
import createClass from 'create-react-class'
import TableForm from 'live/components/forms/ui/TableForm'
import { homeType } from '../utils/constants'
import { RouteApi } from '../api/RouteApi'
import { v4 as uuid } from 'uuid'
import i18n from 'live/services/i18n'
import { NavbarConfigForm } from './NavbarConfigForm'
import { ExtensionInstance } from '../type'

const FormBase = require('live/components/extensions/ui/form')

const FormGroup = require('live/components/forms/ui/form-group')

const ValidationMixin = require('live/components/forms/mixins/validation-mixin')
const ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: homeType,
    active: true,
    config: {
        pageType: '',
        pageName: '',
        uuid: '',
        routes: [],
        defineNavbar: false,
        navbar: []
    },
    fullQualifier: null,
    qualifier: null,
    status: {}
})

const routeApi: RouteApi = new RouteApi()
const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {},
    _onBeforeSubmit: function () {
        const object = this.state.object
        const config = object.config
        const body: ExtensionInstance = {
            uuid: config.uuid,
            pageType: config.pageType,
            pageName: config.pageName,
            routes: config?.routes,
            navbar: config?.navbar,
            defineNavbar: config?.defineNavbar
        }
        routeApi.post(object.config.uuid, body).then()
    },
    _onSuccess: function () {
        window.location.href = '#/platform/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        window.location.href = '#/platform/'
    },
    generateUUID: function () {
        const object = this.state.object
        const config = object.config

        config.uuid = uuid()

        object.config = config

        this.setState(config)
    },
    componentDidUpdate(prevProps, prevState) {
        const object = this.state.object
        const config = object.config
        if (config && !config.uuid) {
            this.generateUUID()
        }
    },
    handleStateChange: function (state) {
        this.setState(state)
    },

    render() {
        const object = this.state.object

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <h3>{i18n('Page config')}</h3>

                    <FormGroup
                        type="text"
                        label={i18n('Page type') + ' (' + i18n('use unique name as identifier') + ')'}
                        name="config.pageType"
                        value={object?.config.pageType}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.pageType')}
                        hasFeedback
                        help={this.errorsFor('config.pageType')}
                    />

                    <FormGroup
                        type="text"
                        label={i18n('Page Name')}
                        name="config.pageName"
                        value={object?.config.pageName}
                        onChange={this.handleValidation}
                        validationState={this.validationState('config.pageName')}
                        hasFeedback
                        help={this.errorsFor('config.pageName')}
                    />

                    <TableForm
                        data={object?.config?.routes || []}
                        allowAddRow={true}
                        allowRemoveRow={true}
                        onChange={routes => {
                            this.setState({ object: { ...object, config: { ...object.config, routes } } })
                        }}
                        fields={[
                            { name: 'icon', label: 'Icon', type: 'text' },
                            { name: 'title', label: 'Title', type: 'text' },
                            { name: 'description', label: 'Description', type: 'text' },
                            { name: 'dashboardId', label: 'Dashboard ID', type: 'text' }
                        ]}
                    />

                    <NavbarConfigForm {...object} setState={this.handleStateChange} stateObject={this.state} />
                </div>
            </FormBase>
        )
    }
})

export default Form
